<div style="background-color:#a5d8c425; height: 100%;">
  <mat-toolbar fxLayout="row" style="background-color: white;">
    <div fxFlex="1 1 40%" fxFlex.gt-sm="70%">
      <a class="pointer mr-4">
        <img width="140px" src="assets/icons/voloHealth.png" /></a>
    </div>
  </mat-toolbar>

  <div class="">

    <div class="col-md-12" style="padding: 50px;">
      <h3>Provider Registration Queries</h3>
      <div class="table_contact mt-4">
        <table mat-table [dataSource]="dataSource" class="table-flex mat-elevation-z8 MM14 width-full">

          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>Raised By</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.createdBy }}
            </td>
          </ng-container>
          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef>Raised Date</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.createdDate | date }}
            </td>
          </ng-container>
          <ng-container matColumnDef="updatedBy">
            <th mat-header-cell *matHeaderCellDef>Responded By</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.updatedBy }}
            </td>
          </ng-container>
          <ng-container matColumnDef="updatedDate">
            <th mat-header-cell *matHeaderCellDef>Responded Date</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.updatedDate | date }}
            </td>
          </ng-container>
          <ng-container matColumnDef="queryRaised">
            <th mat-header-cell *matHeaderCellDef>Query </th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.queryRaised }}
            </td>
          </ng-container>
          <ng-container matColumnDef="queryResponse">
            <th mat-header-cell *matHeaderCellDef>Response</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              {{ element?.queryResponse }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell class="cell_space_util" *matCellDef="let element">
                    {{element?.isActive ? 'active' : 'closed' }}
                  </td>
                </ng-container> -->

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell class="cell_space_util" *matCellDef="let element">
              <!-- <span style="color: #013cdb; cursor:pointer " (click)="openAddQuery(element.id)" > 
                      View
                    </span> -->
                    <button mat-icon-button style="cursor:pointer "
                    (click)="openAddQuery(element.id)" [disabled]="!element.isActive">
                      <mat-icon>edit</mat-icon>
                    </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator class="mat-elevation-z8 full-width-field" [length]="resultsLength" [pageSize]="10"
          showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
</div>